var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2499 16.2707L13.6565 13.6773",
    stroke: "#737A91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8476 6.81944C12.8428 8.23721 12.3401 9.60824 11.4273 10.6931C10.5145 11.778 9.24967 12.5077 7.85361 12.755C6.45756 13.0022 5.01902 12.7512 3.78919 12.0458C2.55936 11.3403 1.61641 10.2253 1.12498 8.89545C0.633559 7.56556 0.624896 6.1053 1.10051 4.76967C1.57611 3.43405 2.50577 2.30794 3.72714 1.58797C4.94851 0.868 6.38397 0.599947 7.78286 0.830597C9.18175 1.06125 10.4552 1.77595 11.3808 2.84991",
    stroke: "#737A91",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarSearchIcon);
export default __webpack_public_path__ + "static/media/navbar-search-icon.a03c7e2a1f098f4b3a2817f53788d953.svg";
export { ForwardRef as ReactComponent };